export const config = {
  apiBase: import.meta.env.VITE_API_BASE ?? '',
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '',
} as const;
